<template>
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29.6 27.7L23.6 21.7C27.8 16.5 27.5 8.8 22.7 3.9C20.2 1.4 16.8 0 13.3 0C9.8 0 6.4 1.4 3.9 3.9C1.4 6.4 0 9.7 0 13.3C0 16.9 1.4 20.2 3.9 22.7C6.5 25.3 9.9 26.6 13.3 26.6C16.3 26.6 19.2 25.6 21.7 23.6L27.7 29.6C28 29.9 28.3 30 28.7 30C29 30 29.4 29.9 29.7 29.6C30.1 29.1 30.1 28.2 29.6 27.7ZM5.8 20.8C3.8 18.8 2.7 16.2 2.7 13.3C2.7 10.5 3.8 7.8 5.8 5.8C7.8 3.8 10.4 2.7 13.3 2.7C16.1 2.7 18.8 3.8 20.8 5.8C24.9 9.9 24.9 16.6 20.8 20.7C16.6 24.9 9.9 24.9 5.8 20.8Z" fill="#3254B9"/>
  </svg>
</template>

<script setup>

</script>

<style scoped lang="scss">

</style>
